import { render, staticRenderFns } from "./ThgQuoteWorkitemRegistrationCard.vue?vue&type=template&id=79b23640"
import script from "./ThgQuoteWorkitemRegistrationCard.vue?vue&type=script&lang=ts"
export * from "./ThgQuoteWorkitemRegistrationCard.vue?vue&type=script&lang=ts"
import style0 from "./ThgQuoteWorkitemRegistrationCard.vue?vue&type=style&index=0&id=79b23640&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports